/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import { Wrapper } from './page-container.style';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
};

/**
 * Export `PageContainer` component.
 */

export function PageContainer({ children }: Props): JSX.Element {
  return <Wrapper>{children}</Wrapper>;
}
